import React, { useEffect, useState } from 'react';
import { apiUrl } from '../../config/api';

export default function MessageMedia({ attachment, headers }) {
  const [url, setUrl] = useState('');
  const [requested, setRequested] = useState(attachment.type === 'image');
  const [error, setError] = useState('');
  const [retry, setRetry] = useState(0);
  useEffect(() => {
    if (!requested || !attachment.url) return undefined;
    setError(''); setUrl('');
    let cancelled = false; let objectUrl;
    const controller = new AbortController();
    fetch(apiUrl(attachment.url), { headers: headers(), signal: controller.signal }).then(async response => {
      if (!response.ok) throw new Error('No se pudo cargar el adjunto. Reintenta o ábrelo en el proveedor.');
      const blob = await response.blob();
      if (cancelled) return;
      objectUrl = URL.createObjectURL(blob); setUrl(objectUrl);
    }).catch(err => { if (!cancelled) setError(err.message); });
    return () => { cancelled = true; controller.abort(); if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [requested, attachment.url, headers, retry]);
  if (!attachment.url) return <p>Adjunto no compatible. Revisa la conversación en el proveedor.</p>;
  return <div className="message-media">
    {!requested && <button type="button" onClick={() => setRequested(true)}>Cargar {attachment.fileName || 'adjunto'}</button>}
    {url && attachment.type === 'image' && <img className="chat-message-image" src={url} alt={attachment.fileName || 'Imagen adjunta'} />}
    {url && attachment.type === 'audio' && <audio controls preload="metadata" src={url}>Audio adjunto</audio>}
    {url && attachment.type === 'video' && <video controls preload="metadata" src={url} style={{ maxWidth: '100%' }}>Video adjunto</video>}
    {url && <a href={url} download={attachment.fileName || 'adjunto'}>Descargar {attachment.fileName || 'adjunto'}</a>}
    {error && <p role="alert">{error} <button type="button" onClick={() => setRetry(value => value + 1)}>Reintentar adjunto</button></p>}
  </div>;
}
